import { config } from "zod/v4";

config({
  jitless: true
});
